import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import MetisMenu from 'react-metismenu';
import { DashboardComponentsNav } from './Items';

class Nav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navMenulist: []
        }
    }

    componentDidMount() {
        this.setState({
            navMenulist: this.props.navMenulist
        });
    }

    render() {
        return (
            <Fragment>
                <MetisMenu
                    content={DashboardComponentsNav}
                    activeLinkFromLocation
                    className="vertical-nav-menu"
                    iconNamePrefix=""
                    classNameStateIcon="pe-7s-angle-down"
                    classNameContainer="metismenu-container"
                />

                <MetisMenu
                    content={this.state.chatbotMenuList}
                    activeLinkFromLocation
                    className="vertical-nav-menu"
                    iconNamePrefix=""
                    classNameStateIcon="pe-7s-angle-down"
                    classNameContainer="metismenu-container"
                />
            </Fragment>
        );
    }

    isPathActive(path) {
        return this.props.location.pathname.startsWith(path);
    }
}

export default withRouter(Nav);